export const removeItem = (items, id) => {
    return items.filter((item) => item.id !== id);
};

export const setPresetData = (items, id, data) => {
    return items.map((item) => {
        return item.id === id ? data : item;
    });
};
